const errorMessage = "This field is required";

export default errorMessage;
